import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

export default function AddressCardSkeleton() {
  return (
    <div className="col-sm-6 col-lg-4 mt-4">
      <div className="create-favListAdd">
        <div className="favListing">
          <div className="addressDetails">
            <address className="text-dark">
              <b>
                <Skeleton width={120} height={18} />
              </b>
              <Skeleton width={180} />
              <Skeleton width={160} />
              <Skeleton width={140} />
              <Skeleton width={100} />
            </address>

            <div className="addressDetails-contact mt-3">
              <p>
                <b>Phone Number:</b> <Skeleton width={120} />
              </p>
            </div>
          </div>
        </div>

        <div className="favListing-links d-flex gap-2 mt-2">
          <Skeleton width={50} height={30} borderRadius={6} />
          <Skeleton width={60} height={30} borderRadius={6} />
        </div>
      </div>
    </div>
  );
}
